import { z } from 'zod'

export const hungarianPhonePattern =
  /^(?:\+36|06)(?:\s?\d{1,2}){1}(?:\s?\d{3})(?:\s?\d{3,4})$/

export const uploadedImageSchema = z.object({
  path: z.string(),
  url: z.string().url(),
  fileName: z.string(),
})

export const bookingSchema = z
  .object({
    appointmentDate: z.date().nullable(),
    timeslotId: z.string().min(1, 'Please select a timeslot.'),
    guestCount: z.number().int().min(1, 'At least one guest is required.').max(5, 'A maximum of five guests may attend.'),
    name: z.string().min(1, 'Please enter your full name.'),
    email: z.string().min(1, 'Please enter your email address.').email('Please provide a valid email address.'),
    phone: z
      .string()
      .min(1, 'Please enter your phone number.')
      .refine(
        (value) => {
          const normalised = value.replace(/\s+/g, '')
          return hungarianPhonePattern.test(normalised)
        },
        { message: 'Please enter a valid Hungarian phone number (+36 or 06).' },
      ),
    additionalGuests: z.array(
      z
        .string()
        .trim()
        .min(2, 'Guest name must be at least 2 characters.'),
    ),
    image: uploadedImageSchema.nullable(),
  })
  .superRefine((data, ctx) => {
    if (!data.appointmentDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['appointmentDate'],
        message: 'Please select an available date.',
      })
    }

    if (!data.image) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['image'],
        message: 'Please upload your SUPERZ perfume bottle photo.',
      })
    }

    const expectedAdditionalGuests = Math.max(0, data.guestCount - 1)
    if (data.additionalGuests.length !== expectedAdditionalGuests) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['additionalGuests'],
        message:
          expectedAdditionalGuests > 0
            ? `Please provide the names of all ${expectedAdditionalGuests} additional guest${expectedAdditionalGuests === 1 ? '' : 's'}.`
            : 'No additional guests are expected for this booking.',
      })
    }
  })

export type BookingFormSchema = z.infer<typeof bookingSchema>
